<template>
  <b-modal id="modal-upload-video" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Upload novo video</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-upload-video')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-video"></i> Dados do vídeo</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomeVideo"  label="Nome do vídeo *" :text="{ required: 'Obrigatório informar o nome do vídeo' }" :field="$v.video.video">
            <input type="text" class="form-control" id="nomeVideo" placeholder="" v-model="video.video" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="arquivoVideo"  label="Arquivo do video *" :text="{ required: 'Obrigatório informar o vídeo' }" :field="$v.file">
                      <b-form-file
                        v-model="file"
                        placeholder="Selecionar video"
                        browse-text="Selecionar"
                        accept="video/*"
                        ref="formFile"
                      ></b-form-file>
          </form-group>

        </div>
        <div class="col-12 col-md-12">
          <form-group id="nomeCoordenador"  label="Coordernador *" :text="{ required: 'Obrigatório informar o nome do coordenador' }" :field="$v.video.coordenador">
            <select class="form-control" id="nomeCoordenador" v-model="video.coordenador">
              <option value="">Selecione</option>
              <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
            </select>
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <form-group id="nomeProfessor" label="Professor *" :text="{ required: 'Obrigatório informar o nome do professor' }" :field="$v.video.professor">
                <select class="form-control" id="nomeProfessor" v-model="video.professor">
                  <option value="">Selecione</option>
                  <option v-for="professor in professores" :value="professor.id" v-bind:key="professor.id">{{ professor.professor }}</option>
                </select>
              </form-group>
          </div>
        </div>
      </div>
      <h6><i class="fas fa-film"></i> Duração do vídeo</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Horas</label>
                <input type="number" min="0" class="form-control" id="horasVideo" placeholder="" v-model="horas" value="" @input="alteraDuracao()"/>
              </div>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Minutos</label>
                <input type="number" min="0" class="form-control" id="minutosVideo" placeholder="" v-model="minutos" value="" @input="alteraDuracao()"/>
              </div>
          </div>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
              <div>
                <label>Segundos</label>
                <input type="number" min="0" class="form-control" id="segundosVideo" placeholder="" v-model="segundos" value="" @input="alteraDuracao()"/>
              </div>
          </div>
        </div>
        <div class="col-12 col-md-12">
            <span>Duração: </span> {{ video.duration + ' segundos'}}
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="cadastrarVideo">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-upload-video')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>
<script>
import Swal from 'sweetalert2'
import VideoAPI from '@/api/video-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'

export default {
  name: 'ModalUploadVideo',
  components: {
    FormGroup
  },
  inheritAttrs: false,
  props: {
    professores: Array
  },
  data () {
    return {
      video: {
        video: '',
        coordenador: '',
        professor: '',
        vimeo: '',
        duration: 0
      },
      file: null,
      horas: 0,
      minutos: 0,
      segundos: 0,
      loader: null
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      this.video = {
        video: '',
        coordenador: '',
        professor: '',
        vimeo: '',
        duration: 0
      }
      this.file = null
    })
  },

  validations: {
    video: {
      video: { required },
      coordenador: { required },
      professor: { required },
      duration: { required }
    },
    file: { required }
  },

  methods: {
    alteraDuracao: function () {
      if (this.horas === '') {
        this.horas = 0
      }
      if (this.minutos === '') {
        this.minutos = 0
      }
      if (this.segundos === '') {
        this.segundos = 0
      }
      this.video.duration = parseInt(this.horas) * 3600 + parseInt(this.minutos) * 60 + parseInt(this.segundos)
    },

    show: function () {
      this.$bvModal.show('modal-upload-video')
    },
    cadastrarVideo: async function () {
      this.$v.video.$touch()
      this.$v.file.$touch()
      if (!this.$v.video.$invalid && !this.$v.file.$invalid) {
        try {
          this.loader = this.$loading.show()
          const body = { // TODO: Incluir campos de privacidade, local, licença, etc. De acordo com os padrões da Jaleko
            'upload': {
              'approach': 'tus',
              'size': this.file.size
            },
            name: this.video.video
          }
          let dadosVideo = await VideoAPI.geraUrlUploadVimeo(body)
          this.video.vimeo = dadosVideo.data.uri.split('/')[2]
          var uploadUrl = dadosVideo.data.upload.upload_link
          const reader = new FileReader()
          reader.onload = async r => { this.uploadVimeo(uploadUrl, r.target.result) }
          reader.readAsArrayBuffer(this.file)
        } catch (error) {
          if (this.video.vimeo !== '') {
            await VideoAPI.deletarVideoVimeo(this.video.vimeo)
          }
          ResponseUtils.handleError(error, this.loader)
        }
      }
    },

    uploadVimeo: async function (uploadUrl, fileBinary) {
      try {
        await VideoAPI.uploadVimeo(uploadUrl, fileBinary)
        await VideoAPI.salvarVimeo(this.video)
        this.loader.hide()
        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Vídeo criado com sucesso!'
        }).then(() => {
          this.$bvModal.hide('modal-upload-video')
          this.video = {
            video: '',
            coordenador: '',
            professor: '',
            vimeo: 0,
            duration: null
          }
          this.file = null
          this.horas = 0
          this.minutos = 0
          this.segundos = 0
          this.$emit('videoSalvo')
        })
      } catch (error) {
        await VideoAPI.deletarVideoVimeo(this.video.vimeo)
        ResponseUtils.handleError(error, this.loader)
      }
    }
  }
}
</script>
